import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-image: url("./images/backGroud_login.svg");
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
`;

export const ContainerConsultancy = styled.div`
  border-radius: 0 0 0 25px;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin: 20px auto;
`;

export const ContainerSecunday = styled.div`
  display: flex;
  width: 100%;
  
`;

export const ContainerSecundayConsultancy = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
`;

export const ContainerTimer = styled.div`
  align-items: center;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  background-color: #fa821f;
  color: #fff;
  display: flex;
  height: 70px;
  justify-content: space-between;
  width: 100%;
  margin: 10px 0px; 
  padding: 0px 10px;
  border-top-right-radius: 75px;
  border-bottom-right-radius: 75px;

  img {
    width: 70px;
  }

  p {
    font-size: 18px;
  }

  input {
    width: 70px;
    height: 30px;
    border-radius: 20px;
    text-align: center;
    font-size: 18px;
  }
`;

export const ContainerInputConsultancy = styled.div`
  align-items: center;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  background-color: #fa821f;
  color: #fff;
  display: flex;
  height: 60px;
  justify-content: space-between;
  width: 100%;
  margin: 10px auto;
  padding: 0px 10px;

  p {
    font-size: 18px;
  }

  input {
    height: 45px;
    width: 80px;
    border-radius: 20px;
    text-align: center;
    font-size: 18px;
  }

  div {
    display: flex;
    align-items: center;

    p {
      font-size: 24px;
      margin-right: 10px;
      font-weight: bold;
    }
  }
`;


export const ContainerHeaderConsultancy = styled.div`
  align-items: center;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  background-color: #fa821f;
  color: #fff;
  display: flex;
  height: 60px;
  justify-content: center;
  width: 100%;
  margin: 10px auto;
  padding: 0px 10px;
  border-radius: 25px;
`;


export const IconConsultancy = styled.img`
  border: 5px solid #fa821f;
  box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);
  border-radius: 50px;
  position: absolute;
  width: 100px;
  height: 100px;
  background: #fa821f;
`;

export const TitleConsultancy = styled.h2`
  align-items: center;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  background-color: #fa821f;
  border-radius: 100px 0 0 50px;
  color: #fff;
  display: flex;
  height: 70px;
  justify-content: center;
  width: 100%;
`;


export const ContainerStock = styled.h2`
  align-items: center;
  background-color: #fa821f;
  display: flex;
  flex-direction: column;
  font-size: 25px;
  font-weight: bold;
  justify-content: center;
  margin: 25px 0 0;
  width: 100%;
  padding: 20px;

  span {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }

  section {
    margin-top: 30px;
    align-items: center;
    display: grid;
    grid-template-columns: auto auto auto auto;
    gap: 20px;
  }
`;

export const SizeContainer = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 500px;
  padding-bottom: 50px;
  width: 100%;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  padding: 0 35px;
  width: 100%;
  p {
    align-items: center;
    background-color: #fa821f;
    border-radius: 5px;
    display: flex;
    font-size: 22px;
    justify-content: space-between;
    padding: 3px;
    width: 160px;
  }
  span {
    align-items: center;
    background-color: #fff;
    border-radius: 5px;
    color: #737373;
    display: flex;
    height: px;
    justify-content: center;
    width: 50px;
  }
`;

export const MainContainer = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AccumulatedHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 90%;
  h3 {
    background-color: #fa821f;
    border-radius: 5px;
    padding: 3px 10px;
  }
`;

export const ButtonRequest = styled.button`
  background-color: #fa821f;
  box-shadow: 0 -2px 8px 1px rgba(0, 0, 0, 0.3);
  font-size: 22px;
  font-weight: bold;
  height: 60px;
  width: 100%;
`;
